// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"_0d624b9a27--wrapper--mRdae","item":"_0d624b9a27--item--icj8s","description":"_0d624b9a27--description--I_GUf"};